<template>
	<div>
		<div v-if="deskLoading" class="loading-wrapper">
			<div class="loader loader-7"></div>
		</div>

		<!-- Desktop -->
		<FullCalendar
			v-if="!mobileBool"
			ref="fullCalendar"
			id="fullcalendar"
			:options="calendarOptions"
		>
			<template v-slot:eventContent="arg">
				<div
					:class="[
						arg.event.extendedProps.ticketsAvail === 0
							? 'event--notAvailable'
							: '',
						arg.event.start < new Date() ? 'event--notAvailable' : '',
					]"
					class="event"
					@click="
						showModal(
							arg.event.extendedProps.index,
							arg.event.extendedProps.tessId
						)
					"
				>
					<p class="event__time">{{ arg.event.extendedProps.time }}</p>
					<p class="event__title">{{ arg.event.title }}</p>
					<div class="event__button">
						<p v-if="arg.event.extendedProps.gaRequired">Learn more</p>
						<p v-else>Add ticket</p>
					</div>
				</div>
			</template>
		</FullCalendar>

		<!-- Mobile -->
		<div v-if="mobileBool">
			<div v-if="mobileLoading" class="loading-wrapper">
				<div class="loader loader-7"></div>
			</div>
			<datepickerMob
				class="dateItem datePick eventsDatepicker"
				:disabled-dates="this.eventDatepickerOptions[0]"
				v-model="datePicked"
				model-type="yy-m-d"
				inline
				auto-apply
			>
			</datepickerMob>
			<transition name="date-transition">
				<div
					ref="events"
					class="event__container"
					v-if="eventsOnDayPicked !== null"
				>
					<h3 class="event__h3">Events</h3>
					<div
						@click="
							showModal(item.extendedProps.index, item.extendedProps.tessId)
						"
						:class="[
							item.extendedProps.ticketsAvail === 0
								? 'event--notAvailable'
								: '',
							new Date(item.start) < new Date() ? 'event--notAvailable' : '',
						]"
						class="event"
						v-for="item in eventsOnDayPicked"
						v-bind:key="item.id"
					>
						<p class="event__time">{{ item.extendedProps.time }}</p>
						<p class="event__title">{{ item.title }}</p>
						<div class="event__button"><p>Add ticket</p></div>
					</div>
				</div>
			</transition>
			<!-- <div v-if="eventsOnDayPicked.length === 0"></div> -->
		</div>
	</div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import Datepicker from 'vuejs-datepicker';
import { set } from 'vue';
var Vue = require('vue');

export default {
	props: {
		mobile: Boolean,
	},
	data() {
		return {
			startDate: null,
			endDate: null,
			performanceIds: null,
			eventIndex: null,
			tessEvents: null,
			mobileBool: null,
			mobileLoading: false,
			deskLoading: false,
			id: null,
			index: null,
			weekEvents: null,
			todayDate: new Date(),
			datePicked: null,
			noEvents: null,
			gteArray: null,
			monthValues: null,
			ticketInfo: null,
			eventsOnDayPicked: null,
			daysWithoutEvents: [],
			calendarOptions: {
				plugins: [dayGridPlugin],
				initialView: 'dayGridWeek',
				contentHeight: 'auto',
				dayHeaderFormat: { weekday: 'short' },
				headerToolbar: {
					right: 'prev,next',
					left: 'title',
				},
				events: [],
			},
			eventDatepickerOptions: [
				{
					to: new Date(),
					dates: [],
				},
			],
		};
	},
	props: ['eventModalIndex', 'noModal'],
	components: { FullCalendar, DatepickerMob: Datepicker },
	mounted() {
		let that = this;

		this.calendarOptions.contentHeight = 550;
		$('.harness').show();
		// let yesterday = new Date();
		// this.yesterday = yesterday.setDate(yesterday.getDate() - 1);
		jQuery(document).ready(function ($) {
			$(window).resize(function () {
				that.getMobile();
			});
			$('.harness').click(function () {
				that.calendarOptions.contentHeight = 'auto';
			});
			$('.fc-prev-button').click(function () {
				that.getMobile();
				that.inputDays();
				that.calendarOptions.contentHeight = 550;
			});
			$('.fc-next-button').click(function () {
				that.getMobile();
				that.inputDays();
				that.calendarOptions.contentHeight = 550;
			});
			$('.prev').click(function () {
				that.mobilePrevMonth();
				that.eventsOnDayPicked = null;
			});
			$('.next').click(function () {
				that.mobileNextMonth();
				that.eventsOnDayPicked = null;
			});
		});
		this.getMobile();
		this.inputDays();
		this.checkParams();
	},
	computed: {
		formatDatePicked() {
			if (this.datePicked === null || this.datePicked === undefined) {
				return null;
			}
			return this.datePicked.toISOString().slice(0, 10);
		},
	},
	watch: {
		index() {
			if (this.index !== null && this.id) {
				this.showModal(this.index, this.id);
			}
		},
		ticketInfo() {
			if (this.ticketInfo === null || this.ticketInfo === undefined) {
				return;
			}
			this.getTicketTextInfo();
		},
		formatDatePicked() {
			if (
				this.formatDatePicked === null ||
				this.formatDatePicked === undefined
			) {
				return;
			}
			this.getDaysEvents();
		},
		mobileBool() {
			if (this.mobileBool === null) {
				return;
			} else {
				this.setStartDates();
			}
		},
		eventModalIndex() {
			if (this.eventModalIndex === null) {
				return;
			}
			this.weekEvents[this.eventModalIndex].extendedProps.showModal = false;
		},
		startDate() {
			if (this.startDate === null || this.endDate === null) {
				return;
			}
			this.getTessEvents();
		},
		performanceIds() {
			if (this.performanceIds === null) {
				return;
			}
			this.availableTicketsCheck();
		},
		tessEvents() {
			if (this.tessEvents === null) {
				return;
			}
			// this.consolidateEvents();
			this.mergeTessAndAvailablity();
		},
		monthValues() {
			if (this.monthValues === null || this.monthValues === undefined) {
				return null;
			}
			this.datePickerGetValues();
		},
		weekEvents() {
			this.$nextTick();
			if (this.weekEvents === null || this.weekEvents === undefined) {
				this.deskLoading = false;
				return;
			}
			this.deskLoading = false;
			this.seeMoreEventsDetection();
			const windowLocation = window.location.search;
			const urlParams = new URLSearchParams(windowLocation);
			const id = urlParams.get('id');
			if (id) {
				this.id = id;
				let itemId = parseInt(id);
				function getIndexById(array, itemId) {
					return array.findIndex((item) => item.id === itemId);
				}
				let itemIdToFind = itemId;
				this.index = getIndexById(this.weekEvents, itemIdToFind);
			}
			this.$nextTick();
		},
		eventsOnDayPicked() {
			if (
				this.eventsOnDayPicked !== null &&
				this.eventsOnDayPicked.length > 0
			) {
				setTimeout(() => {
					this.$refs['events'].scrollIntoView({ behavior: 'smooth' });
				}, '500');
			}
		},
		calendarOptions() {
			this.$nextTick();
		},
	},
	methods: {
		consolidateEvents() {
			console.log(this.tessEvents);
		},
		checkParams() {
			const windowLocation = window.location.search;
			const urlParams = new URLSearchParams(windowLocation);
			const id = urlParams.get('id');
			if (!id) {
				this.id = null;
				this.index = null;
			}
		},
		seeMoreEventsDetection() {
			let we = this.weekEvents;
			let weArr = [];
			we.forEach((event) => {
				let date = new Date(event.start);
				date = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
					.toISOString()
					.split('T')[0];
				weArr.push(date);
			});

			let counts = {};
			weArr.forEach(function (x) {
				counts[x] = (counts[x] || 0) + 1;
			});

			let weVals = Object.values(counts);
			let weKeys = Object.keys(counts);

			// if (this.mobileBool) {
			weVals.forEach((val, index) => {
				if (val >= 3) {
					let datadate = weKeys[index];
					$('.fc-daygrid-day[data-date=' + datadate + ']').append(
						'<div class="harness"><div class="harness__btn"><p>See more<p></div></div>'
					);
				}
			});

			let that = this;
			jQuery(document).ready(function ($) {
				$('.harness').click(function () {
					that.calendarOptions.contentHeight = 'auto';
					$('.harness').hide();
				});
			});
			// }

			this.monthValues = weArr;
		},
		getDaysEvents() {
			if (this.weekEvents) {
				this.eventsOnDayPicked = [];
				this.weekEvents.forEach((item) => {
					if (item.filterStart === this.formatDatePicked) {
						this.eventsOnDayPicked.push(item);
					}
				});
			}
		},
		datePickerGetValues() {
			function getDaysInMonth(month, year) {
				var date = new Date(year, month, 1);
				var days = [];
				while (date.getMonth() === month) {
					days.push(new Date(date).toISOString());
					date.setDate(date.getDate() + 1);
				}
				return days;
			}
			let startDate = new Date(this.startDate);
			let month = startDate.getMonth();
			let year = startDate.getFullYear();
			let fullMonth = getDaysInMonth(month, year);
			let daysWithEvents = [];
			if (this.monthValues === null) {
				this.monthValues = [];
			}
			this.monthValues.forEach((item) => {
				let eventDate = new Date(item + 'T00:00');
				let dayOfMonth = eventDate.getDate();
				eventDate.setDate(dayOfMonth);
				eventDate.setHours(0o0, 0o0, 0o0);
				eventDate.toISOString();
				daysWithEvents.push(eventDate.toISOString());
			});
			fullMonth = fullMonth.filter((item) => !daysWithEvents.includes(item));
			this.daysWithoutEvents = [];
			let today = new Date();
			today.setHours(0, 0, 0, 0);
			today = today.setDate(today.getDate() - 1);
			this.today = new Date(today);
			this.eventDatepickerOptions[0].to = new Date(today);
			fullMonth.forEach((item) => {
				let date = new Date(item);
				this.eventDatepickerOptions[0].dates.push(date);
			});
			this.mobileLoading = false;
		},
		getMobile() {
			let width = window.innerWidth;
			if (width >= 768) {
				this.mobileBool = false;
				this.setStartDates('desktop');
			} else {
				this.mobileBool = true;
				this.setStartDates('mobile');
			}
		},

		inputDays() {
			let days = document.querySelectorAll('.fc-daygrid-day');
			days.forEach((day) => {
				let date = day.getAttribute('data-date');
				date = date.slice(8, 11);
				day.innerHTML = `<div class='dayText'>${date}</div>`;
			});
		},
		showModal(index, id) {
			// console.log(this.weekEvents);
			// this.weekEvents[index].zones = this.weekEvents.filter(
			// 	(obj) => obj.id === id && obj.extendedProps.ticketsAvail > 0
			// );
			// console.log(this.weekEvents[index]);
			this.eventIndex = index;
			this.weekEvents[index].extendedProps.showModal = true;
			this.weekEvents[index].index = index;
			this.getModalDetails(id);
		},
		getModalDetails(id) {
			let that = this;
			$.get(
				'/actions/my-module/default/event-details',
				{ id: id },
				function (res) {
					let jsonData = JSON.parse(res);
					if (jsonData.length > 0) {
						jsonData[0].WebContents.forEach((el) => {
							// setting numerical values to variable and their reference point
							if (el.Type.Id === 32) {
								that.weekEvents[that.eventIndex].extendedProps.image = el.Value;
							} else if (el.Type.Id === 33) {
								that.weekEvents[that.eventIndex].extendedProps.link = el.Value;
							} else if (el.Type.Id === 34) {
								that.weekEvents[that.eventIndex].extendedProps.address =
									el.Value;
							}
						});
					}
				}
			).done(function () {
				let event = that.weekEvents[that.eventIndex];
				that.$emit('renderModal', event);
			});
		},
		mergeTessAndAvailablity() {
			if (this.tessEvents === null || this.gteArray === null) {
				return;
			}

			let arr = [];
			arr = this.tessEvents.map((t1) => ({
				...t1,
				...this.gteArray.find((t2) => t2.id === t1.id),
			}));
			let arr2 = arr.map((item, index) => ({
				title: item.title,
				start: item.start,
				filterStart: item.start.slice(0, 10),
				end: item.start,
				id: item.id,
				extendedProps: {
					time: item.startStr,
					tessId: item.id,
					index: index,
					ticketsAvail: item.availableCount,
					availSaleIndicator: item.avialSaleIndicator,
					zone: item.zone,
					desc: item.desc,
					showModal: false,
					gaRequired: item.gaRequired,
				},
			}));
			this.weekEvents = arr2;
			// console.log(arr2);
			this.calendarOptions.events = [...this.weekEvents];
		},
		availableTicketsCheck() {
			let that = this;
			if (that.performanceIds.length > 0) {
				$.get(
					'/actions/my-module/default/available-tickets-check',
					{ arrayOfIds: that.performanceIds },
					function (res) {
						let jsonData = JSON.parse(res);
						let eligible = jsonData.filter(function (item) {
							return item.Zone.ZoneMapId !== 72;
						});
						eligible = eligible.map((item) => ({
							availableCount: item.AvailableCount,
							id: item.PerformanceId,
							zone: item.Zone.Id,
						}));
						that.tessEvents = eligible;
					}
				);
			}
		},
		mobileNextMonth() {
			this.mobileLoading = true;
			this.startDate = this.endDate;
			let oldEndDate = new Date(this.endDate);
			let oldMonth = oldEndDate.getMonth();
			oldEndDate.setMonth(oldMonth + 1);
			oldEndDate.setHours(0o0, 0o0, 0o0);
			this.endDate = new Date(oldEndDate).toISOString();
		},
		mobilePrevMonth() {
			this.mobileLoading = true;
			this.endDate = this.startDate;
			let newStartDate = new Date(this.startDate);
			let newMonth = newStartDate.getMonth();
			newStartDate.setMonth(newMonth - 1);
			newStartDate.setHours(0o0, 0o0, 0o0);
			newStartDate = new Date(newStartDate).toISOString();
			this.startDate = newStartDate;
		},
		setStartDates(string) {
			switch (string) {
				case 'desktop':
					if (this.mobileBool === false) {
						let startDate = new Date($('.fc-day-sun').attr('data-date'));
						startDate = startDate.toISOString();
						this.startDate = startDate;
						const windowLocation = window.location.search;
						const urlParams = new URLSearchParams(windowLocation);
						const id = urlParams.get('id');
						if (id) {
							let endDate = new Date();
							let endMonth = endDate.getMonth() + 4;
							endDate = endDate.setMonth(endMonth);
							endDate = new Date(endDate);
							this.endDate = endDate.toISOString();
						} else {
							let endDate = new Date($('.fc-day-sat').attr('data-date'));
							endDate.setDate(endDate.getDate() + 1);
							endDate = endDate.toISOString();
							this.endDate = endDate;
						}
					}
					break;
				case 'mobile':
					if (this.mobileBool === true) {
						const windowLocation = window.location.search;
						const urlParams = new URLSearchParams(windowLocation);
						const id = urlParams.get('id');
						if (id && this.noModal == false) {
							let startDate = new Date();
							startDate = startDate.toISOString();
							this.startDate = startDate;
							let endDate = new Date();
							let endMonth = endDate.getMonth() + 4;
							endDate = endDate.setMonth(endMonth);
							endDate = new Date(endDate).toISOString();
							this.endDate = endDate;
						} else {
							let today = new Date();
							let tomorrow = new Date();
							this.startDate = today.toISOString();
							let month = tomorrow.getMonth();
							tomorrow.setDate(1);
							tomorrow.setMonth(month + 1);
							this.endDate = tomorrow.toISOString();
						}
					}
					break;
			}
		},
		getTessEvents() {
			let that = this;
			// use the calendar start and end dates and get the tess events for that week or for mobile: month
			$.get(
				'/actions/my-module/default/get-tess-events',
				{ start: this.startDate, end: this.endDate },
				function (res) {
					let jsonData = JSON.parse(res);
					// return the Events and programs
					let now = new Date();
					let theArray = [];
					jsonData.forEach((el) => {
						let startDate = new Date(el.ModeOfSaleStartDate);
						if (
							(el.ProductionSeason.Description.includes(
								'Events and Programs'
							) &&
								now >= startDate) ||
							(el.ProductionSeason.Description.includes('Sinister Streets') &&
								now >= startDate) ||
							(el.ProductionSeason.Description.includes('Architecture Tour') &&
								now >= startDate)
						) {
							theArray.push(el);
						}
					});
					if (theArray.length === 0) {
						that.monthValues = [];
						that.gteArray = [];
						that.performanceIds = [];
						that.datePickerGetValues();
						that.deskLoading = false;
						return;
					} else {
						// get all of the event Ids
						that.noEvents = false;
						let arr = [];
						theArray.forEach((item) => {
							arr.push(item.PerformanceId);
						});
						let join = arr.join(',');
						that.performanceIds = join;
						let arry = [];
						arry = theArray.map((perf) => ({
							id: perf.PerformanceId,
							title: perf.PerformanceDescription,
							startStr: new Date(perf.PerformanceDate).toLocaleTimeString([], {
								hour: '2-digit',
								minute: '2-digit',
							}),
							desc: perf.SalesNotes,
							start: perf.PerformanceDate,
							avialSaleIndicator: perf.AvailSaleIndicator,
							gaRequired: perf.Text1,
						}));
						that.gteArray = arry;
					}
				}
			);
		},
	},
};
</script>
